import axios from "axios";
import { SERVER_URL } from "../const";


export const getBRCorelationService = async (iec_no) => {
  const token = localStorage.getItem('token');
  try {
    let queryParams = `iec_no=${iec_no}`;

    // Make a GET request to the API endpoint using Axios
    const response = await axios.get(`${SERVER_URL}/master/branch-codes?${queryParams}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};

/**
 * Fetch reference data (license numbers, bill numbers, etc.) from the master data API
 * @param {string} iec_no - IEC number
 * @param {string} type - Type of data to fetch (e.g., 'EPCG', 'ADV_AUTH')
 * @returns {Promise} - Promise resolving to the data array
 */
export const getReferenceDataService = async (iec_no, type) => {
  const token = localStorage.getItem('token');
  try {
    const queryParams = `iec_no=${iec_no}&type=${type}`;

    // Make a GET request to the reference-data/lookup endpoint
    const response = await axios.get(`${SERVER_URL}/reference-data/lookup?${queryParams}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data.data; // Returns the data array
  } catch (error) {
    console.error('Error fetching reference data:', error);
    throw error;
  }
};